<!-- =========================================================================================
  File Name: cameraSetttingSidebarView.vue
  Description: Add New Data - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
        <h4>{{ Object.entries(this.data).length === 0 ? "ADD NEW" : "EDIT" }} CAMERA SETTINGS</h4>
        <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <component :is="scrollbarTag" class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">
      <div class="p-6">
        <!-- MAX LOGIN ATTEMPT -->
        <label>Daily Max Logins</label> <span>  &nbsp;<vs-button size="small" v-html="dataMaxDailyLogins"></vs-button></span>
        <vs-slider :max="10" :min="1" v-model="dataMaxDailyLogins" />
      </div>
    </component>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid">Submit</vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">Cancel</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import {GET_CAMERA_SETTING_DETAILS , UPDATE_CAMERA_SETTING} from "@/graphql";

export default {
  props: {
    isCameraSettingSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    VuePerfectScrollbar
  },
  data () {
    return {

      dataId: null,
      dataMaxDailyLogins:'',


      settings: { // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60
      }
    }
  },
  watch: {
    isCameraSettingSidebarActive (val) {
      if (!val) return
      if (Object.entries(this.data).length === 0) {
        this.initValues()
        this.$validator.reset()
      } else {
        const {id } = JSON.parse(JSON.stringify(this.data))
        this.dataId = id

        this.initValues()
        this.getCameraSettingData(this.dataId)
      }
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get () {
        return this.isCameraSettingSidebarActive
      },
      set (val) {
        if (!val) {
          this.$emit('closeSidebar')
          // this.$validator.reset()
          // this.initValues()
        }
      }
    },
    isFormValid () {
      return !this.errors.any() && this.dataMaxDailyLogins
    },
    scrollbarTag () { return this.$store.getters.scrollbarTag }
  },
  methods: {
    initValues () {
      if (this.data.id) return
      this.dataId = null
      this.dataMaxDailyLogins = ''


    },
    getCameraSettingData(id) {
      // console.log(id)
      this.$apollo
        .query({
          query: GET_CAMERA_SETTING_DETAILS,
          variables: {
            id:  id
          },
        })
        .then(response => {
          if(response.data.getCameraSettingData !=null){
            if(response.data.getCameraSettingData.status=='SUCCESS'){
              this.dataMaxDailyLogins = response.data.getCameraSettingData.daily_logins
            }
          }
          else {
            this.dataMaxDailyLogins = 0

          }
        })
    },
    submitData() {

      if (this.dataMaxDailyLogins != 0) {
        this.$apollo
          .mutate({
            mutation: UPDATE_CAMERA_SETTING,
            variables: {
              id: this.dataId,
              max_logins: this.dataMaxDailyLogins
            }
          }).then(response => {
          if (response.data.updateCameraSetting.status == "SUCCESS") {
            this.successNotificationUpdate()
          } else if (response.data.updateCameraSetting.status == "UPDATED") {
            this.successNotificationUpdate()
          }
        })
      } else {
        this.NotAlloweddNotification()
      }

    },
    successNotificationUpdate() {
      this.$vs.notify({
        title: 'Setting',
        text: 'Saved successfully!',
        color: 'success',
        position: 'top-right'
      })
    },
    successNotification() {
      this.$vs.notify({
        title: 'Reset Daily Logins',
        text: 'Number of logins have been reset for the day.',
        color: 'success',
        position: 'top-right'
      })
    },
    NotAlloweddNotification() {
      this.$vs.notify({
        title: 'Not Allowed',
        text: 'Only greater than 0 value allowed',
        color: 'danger',
        position: 'top-right'
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
    // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
    height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

    &:not(.ps) {
      overflow-y: auto;
    }
}
</style>
